import { Flag } from '@fullstory/proto/fs/shared/flags';
import { useFlags } from '@fullstory/react-hooks';
import {
  AppDispatch,
  fullstorySelectors,
  getCustomEventPropsLoading,
  SearchMetaAsyncRequestActions,
  SearchMetaRequestActions,
} from '@fullstory/redux';
import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getEventPropertiesByEvent } from '../selectors';

export const useProperties = (name: string) => {
  const dispatch = useDispatch<AppDispatch>();
  const orgId = useSelector(fullstorySelectors.getOrgId);
  const flags = useFlags();
  const canArchiveProperties = flags.hasBit(Flag.PermModifyCustomVars);
  const customEventPropsLoading = useSelector(getCustomEventPropsLoading);
  const propertiesByEvent = useSelector(getEventPropertiesByEvent);

  const getConnections = useCallback(() => {
    dispatch(SearchMetaRequestActions.getHiddenVars(orgId));
    dispatch(
      SearchMetaAsyncRequestActions.getCustomSchemaConnections(orgId, {
        events: [name],
      }),
    );
  }, [dispatch, orgId, name]);

  useEffect(() => {
    getConnections();
  }, [getConnections]);

  const { properties, propertiesLoading, propertiesFailed } = useMemo(() => {
    const properties = propertiesByEvent.get(name);
    const propertiesLoading = customEventPropsLoading.has(name);
    const propertiesFailed = !properties && !propertiesLoading;
    return {
      properties: properties ?? [],
      propertiesLoading,
      propertiesFailed,
    };
  }, [name, propertiesByEvent, customEventPropsLoading]);

  return { properties, propertiesLoading, propertiesFailed, getConnections, canArchiveProperties };
};
